import React, { useState, useRef, useEffect } from 'react';
import { Smile } from 'lucide-react';

// Curated, garden-friendly emoji set for quick expression. Tap to insert.
export const EMOJIS = [
  '😀','😃','😄','😁','😊','🙂','😉','😍','😘','😋','😎','🤩','🥳','🤗','🙌','👏',
  '👍','👌','🙏','💪','✨','⭐','🌟','🔥','💚','💛','❤️','🧡','💜','🌱','🌿','🍀',
  '🌸','🌻','🌵','🌾','🍅','🥕','🥬','🥦','🌽','🥔','🍓','🍆','🐝','🦋','☀️','🌧️',
];

// Lightweight emoji picker button + popover (no external dependency).
export default function EmojiPicker({ onSelect, testId = 'emoji-picker' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  return (
    <div className="relative inline-block" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid={`${testId}-button`}
        aria-label="Add emoji"
        className="w-9 h-9 rounded-full hover:bg-[#1A4331]/8 flex items-center justify-center text-[#7A6B57] transition-colors"
      >
        <Smile className="w-5 h-5" />
      </button>
      {open && (
        <div
          data-testid={`${testId}-panel`}
          className="absolute z-50 bottom-11 right-0 w-64 max-h-52 overflow-y-auto bg-white rounded-2xl shadow-2xl border border-[#1A4331]/10 p-2 grid grid-cols-8 gap-1"
        >
          {EMOJIS.map((e) => (
            <button
              key={e}
              type="button"
              onClick={() => { onSelect(e); setOpen(false); }}
              className="w-7 h-7 text-lg leading-none hover:bg-[#F0F2EB] rounded-lg flex items-center justify-center"
            >
              {e}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
